import { gtmEvents } from './gtm';
import { biLogger } from '../hooks';
import { getInitialEmail } from '../config';
import { getSuccessUrl } from 'config/providers';

interface RedirectToPremiumParams {
  metaSiteId: string;
  sessionId: string | null;
}

export async function redirectToPremium({ metaSiteId, sessionId }: RedirectToPremiumParams): Promise<void> {
  if (!metaSiteId) {
    console.error('MetaSiteId is required to redirect to premium');
    return;
  }

  gtmEvents.checkoutClick({
    metaSiteId,
    flow: 'ai-create-store',
    userId: sessionId || undefined,
  });

  const url = new URL('https://premium.wix.com/wix/api/premiumStart');
  url.searchParams.set('siteGuid', metaSiteId);
  url.searchParams.set('referralAdditionalInfo', 'add-domain-purchase-intent-dropshipping');
  url.searchParams.set('petri_ovr', 'specs.premium.RemoveLightPlanForDropShipping:true');

  const successUrl = getSuccessUrl();
  if (successUrl) {
    const redirectUrl = new URL(successUrl);

    const email = getInitialEmail();
    if (email) {
      redirectUrl.searchParams.set('email', email);
    }

    url.searchParams.set('successUrl', redirectUrl.toString());
  }

  const premiumUrl = url.toString();
  biLogger.generateSite(premiumUrl);

  window.location.href = premiumUrl;
}
